(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-portfolio"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-mc-scroll]');
  if (!b) return;
  var track = b.closest('.mc-port').querySelector('.mc-port__track');
  track.scrollBy({ left: parseInt(b.dataset.mcScroll, 10) * Math.max(track.clientWidth * 0.6, 280), behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();
})();
